// extracted by mini-css-extract-plugin
export default {"container":"l1-z","list":"m1-z"};